import React, { ChangeEvent, useCallback, useContext } from "react";
import { NotificationEmail } from "../../../../domain/user/notification/NotificationEmail";
import { NotificationEmailContext } from "../../../provider/NotificationEmailProvider";
import { RemoveIcon } from "../../common/icons/RemoveIcon";

export const EmailListItem = React.memo(function EmailListItem(props: Props) {
    const { email, index } = props;
    
    const { setNotificationEmailList } = useContext(NotificationEmailContext);

    const handleEmailChanged = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        setNotificationEmailList(prevList => (
            prevList.map(it => (
                it.id === email.id ? NotificationEmail.fromString(email.id, e.target.value) : it
            ))
        ));
    }, [email, setNotificationEmailList]);

    const handleEmailListDeleteClicked = useCallback(() => {
        setNotificationEmailList(prevList => prevList.filter(it => it.id !== email.id));
    }, [email, setNotificationEmailList]);

    return (
        <li className="notification_email_row">
            <div className="label">メールアドレス{index + 1}</div>
            <div className="notification_email">
                <div className={"input text_box"}>
                    <input
                        className={"text_box__input"}
                        value={email.value}
                        placeholder={"例：example@mail.com"}
                        onChange={handleEmailChanged}
                    />
                </div>
                <button className={"remove_email"} onClick={handleEmailListDeleteClicked}>
                    <div className={"circle"} />
                    <RemoveIcon />
                </button>
            </div>
        </li>
    );
});

type Props = {
    email: NotificationEmail
    index: number
};
